import * as React from 'react';
import {styled} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import {useDispatch, useSelector} from "react-redux";
import {setRightDrawer} from "../../Modules/Common/App";

const StyledDrawer = styled(MuiDrawer)(({ theme }) => ({
    zIndex: 9999,
    left:'auto',
    maxWidth: `${theme?.rightDrawer?.width || 500}px`,
    width: "100%",
    "& .MuiDrawer-paper": {
        position: "relative",
        "& .MuiCard-root": {
            width: "100%",
            height: "100%",
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            '& .MuiCardHeader-root': {
                position:'relative',
                padding: theme.spacing(2),
                '& .MuiCardHeader-title': {
                    fontSize: '1rem',
                    paddingLeft: theme.spacing(0),
                    fontWeight: 500,
                    color: '#333333',
                },
                '& .MuiLinearProgress-root': {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                },
            },
            "& .MuiCardContent-root": {
                flex: 1,
                overflow: "auto",
            },
            "& .MuiCardActions-root": {
                padding: theme.spacing(2),
                display: "flex",
                justifyContent: "space-between",
            },
        },
    },
}));

export const RightDrawer = () => {

    const app = useSelector((store) => store.app);
    const dispatch = useDispatch();
    const open = app.rightDrawer.open;
    const component = app.rightDrawer.component;

    return (
        <StyledDrawer
            anchor="right"
            open={open}
            onClose={ () => dispatch(setRightDrawer({component:null, open:false})) }
        >
            {React.isValidElement(component) ? component : null}
        </StyledDrawer>
    );
}
